<template>
  <div class="balance" :class="{'active': isDropdownOpen.balance && !isChasbox}">
    <div class="balance-item">
      <UiText
        color="typography-body01"
        font="body-text"
        :text="label"
        class="balance-item__label"
      />
      <div class="balance-item__value">
        <slot name="value">
          <UiText
            font="promo-heading-2"
            :text="value"
            color="button-default-text-color"
            class="balance-item__sum"
          />
          <UiText
            font="promo-heading-3"
            :text="currency"
            color="button-default-text-color"
            class="balance-item__currency"
          />
        </slot>
      </div>
    </div>
    <SvgIcon
      v-if="!isChasbox"
      :class="{'active': isDropdownOpen.balance && !isChasbox}"
      class="balance__icon"
      name="chevrons/chevron-down"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CashboxBalanceItem',
  props: {
    label: { type: String, required: true },
    value: { type: [String, Number], required: false },
    currency: { type: String, required: false, default: '₴' },
  },
  computed: {
    ...mapGetters('base', ['isDropdownOpen']),
    isChasbox() {
      return this.$route.path.includes('cashbox')
    },
  },
}
</script>

<style lang="scss" scoped src="./style.scss" />
